import 'bootstrap/dist/css/bootstrap.min.css'
import '@splidejs/react-splide/css'
import './App.css'
import './responsive.css'
import Router from './Router'
import { useEffect, useState } from 'react'
import DesktopView from './pages/DesktopView'
import { useLocation } from 'react-router'

function App () {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isAdminRoute = location.pathname.includes('/contab-admin');

  if (isDesktop && !isAdminRoute) {
    return <DesktopView />;
  }

  return (
      <Router />
  )
}

export default App
